import React from "react";
import { appUrl } from "@/constants";
import { WebViewUI } from "@/components/webview-ui";

export default function PrivacyPolicyScreen() {
    const privacyUrl = `${appUrl}/mobile/privacy-policy`;

    return (
        <WebViewUI title="Privacy Policy" url={privacyUrl} />
    );
}
